import React from "react";
import Button from "./button";
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: props => (props.size === 'medium' ? '500px' : '700px'),
  },
  buttonContainer: {
    paddingTop: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  secondaryButton: {
    paddingLeft: '20px',
  }
}));

export default function CustomModal({
  showModal,
  size,
  title,
  children,
  onCloseModal,
  onSubmit,
  cancelBtnDisabled = false,
  cancelBtnText = 'Cancel',
  submitBtnText = 'Submit',
  submitBtnDisabled,
  loading,
  secondaryRightBtnText,
  onSecondaryRightBtnSubmit,
  secondaryBtnLoading
}) {
  const classes = useStyles({ size });

  return (
    <Modal
      className={classes.modal}
      open={showModal}
      onClose={onCloseModal}
      closeAfterTransition
      disableBackdropClick
    >
      <Fade in={showModal}>
        <div className={classes.paper}>
          {title && <h2 id="transition-modal-title">{title}</h2>}
          <div>{children}</div>
          <div className={classes.buttonContainer}>
            <Button variant="contained" color="primary" onClick={onCloseModal} disabled={cancelBtnDisabled}>
              {cancelBtnText}
            </Button>
            <div>
              <Button
                variant="contained"
                color="secondary"
                loading={loading}
                onClick={onSubmit}
                disabled={submitBtnDisabled}
              >
                {submitBtnText}
              </Button>
              {secondaryRightBtnText && (
                <span className={classes.secondaryButton}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={onSecondaryRightBtnSubmit}
                    disabled={secondaryBtnLoading}
                    loading={secondaryBtnLoading}
                  >
                    {secondaryRightBtnText}
                  </Button>
                </span>
              )}
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
